import { j as l } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const e = a((s, c) => /* @__PURE__ */ l.jsx(
  i,
  {
    ref: c,
    ...s,
    image: (o) => /* @__PURE__ */ l.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 91,
        height: 101,
        fill: "none",
        viewBox: "0 0 91 101",
        ...o,
        children: [
          /* @__PURE__ */ l.jsx(
            "path",
            {
              fill: "#1D1D44",
              d: "M73.04 75.02c-.09.21-.17.42-.26.63C67.84 86.86 59.31 95.21 49.96 98c-2.33.69-6.26.69-8.59 0-9.36-2.78-17.89-11.14-22.83-22.35-.09-.2-.17-.41-.26-.62-.07 1.1-.1 2.22-.1 3.39 5.22 10.52 13.6 18.29 22.76 21.02 1.3.39 3.01.58 4.72.58s3.42-.19 4.72-.58c9.18-2.73 17.57-10.54 22.76-21.03 0-1.16-.03-2.29-.1-3.38z"
            }
          ),
          /* @__PURE__ */ l.jsx(
            "path",
            {
              fill: "#1D1D44",
              d: "M45.66 85.54c1.22 0 2.43-.46 3.36-1.39l2.28-2.28-.99-.99-2.28 2.28a3.356 3.356 0 0 1-4.73 0l-2.28-2.28-.99.99 2.28 2.28c.93.93 2.14 1.39 3.36 1.39zM52.95 90.82l-.55-1.29c-6.64 2.85-13.41.03-13.47 0l-.55 1.29c.2.08 3.34 1.4 7.53 1.4 2.16 0 4.6-.35 7.05-1.4zM37.94 60.07l.81-1.26c-2.53-1.64-9.7-3.7-14.83-2.74-.36.59-.71 1.2-1.05 1.82 4.35-1.58 12.16.29 15.07 2.18M38.35 64.7l-.8-1.16c-6.02 4.17-11.97.17-12.23 0l-.8 1.16s3.13 2.11 7.19 2.11c2.05 0 4.35-.53 6.63-2.11zM52.57 58.81l.81 1.26c2.91-1.88 10.71-3.76 15.06-2.18-.34-.62-.69-1.23-1.06-1.82-5.13-.96-12.29 1.1-14.82 2.74zM66.8 64.7l-.8-1.16c-.25.17-6.21 4.17-12.22 0l-.8 1.16c2.29 1.58 4.58 2.11 6.63 2.11 4.07 0 7.14-2.08 7.19-2.11"
            }
          ),
          /* @__PURE__ */ l.jsx(
            "path",
            {
              fill: "#1D1D44",
              d: "M89.44 43.66C85.52 16.28 67.82 0 45.66 0S5.81 16.28 1.89 43.66C.1 56.15.66 76.06 1.65 83.88c1.1 8.78 19.05 13.49 19.05 13.49-1.75-7.17-2.51-13.44-2.52-18.95 0-1.16.04-2.29.1-3.39.41-6.91 2.1-12.52 4.59-17.13.34-.62.68-1.23 1.05-1.82 4.9-7.91 12.22-12.66 19.02-16.08-1.5-.12-2.77-.11-3.43.06 2.14-1.78 3.83-2.53 6.13-2.98-4.27-.66-10.99.5-13.7 1.64 3.01-3.76 7.24-6.67 13.68-8.39-7.3-.85-13.68.19-18.79 1.56 3.07-1.64 9.01-4.29 15.4-4.97-9.43-.66-12.9.64-19.07 2.56 4.38-3.42 7.85-5.13 17.95-5.77-4.49-2.56-6.73-3.21-14.28-2.56 9.23-6.41 16.52-6.41 16.52-6.41-3.93-1.28-8.41-1.28-13.85-.33l.03-.02c4.29-2.23 7.99-4.14 14.37-4.14-1.37-1-5.05-1.92-8.25-1 2.65-2.85 6.04-2.85 9.97-3.49-1.15-.64-3.39-.64-6.2 0 1.68-2.56 4.49-3.45 6.57-3.98 2.8.83 5.35 2.24 7.46 5.26-2.8 0-5.05.64-6.17 2.2 2.81-.92 9.02-.76 11.15.57 0 0-3.5.66-6.05 2.95 6.05-.3 8.94 1.39 11.49 3.01-5.93 0-9.3 0-14.91 3.45 7.47-.66 14.86.56 20.2 3.21-6.4-.66-11.22.64-17.39 2.56 9.54.64 14.27 4.05 16.83 5.77-10.67-.66-15.15-1.28-20.2 1.28 9.54 1.28 11.78 2.56 14.3 6.67-3.07-1.09-5.72-3.27-12.61-2.19 4.49.64 6.21 2.59 7.28 3.72-2.64-.85-5.3-.92-9.13-.23 2.1.78 4.04 2.07 4.03 2.07 5.59 3.23 11.15 7.58 15.13 13.99.37.59.72 1.2 1.06 1.82 2.49 4.61 4.18 10.22 4.6 17.12.07 1.1.1 2.22.1 3.38 0 5.52-.77 11.79-2.52 18.96 0 0 17.95-4.71 19.05-13.49.99-7.82 1.55-27.73-.24-40.22z"
            }
          )
        ]
      }
    )
  }
));
e.displayName = "HairLossFemale3Icon";
export {
  e as HairLossFemale3Icon,
  e as default
};
//# sourceMappingURL=index.js.map
